import { NETWORK_PATH, NETWORK_STATUS } from 'modules/network/constants'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'

/**
 * Sets the network status to online.
 * @returns {Function}
 */
function onlineNetworkAction () {
  const path = NETWORK_PATH.STATUS
  const value = NETWORK_STATUS.ONLINE
  return updateLegacyReduxAction({
    path,
    value
  })
}

/**
 * Sets the network status to offline.
 * @returns {Function}
 */
function offlineNetworkAction () {
  const path = NETWORK_PATH.STATUS
  const value = NETWORK_STATUS.OFFLINE
  return updateLegacyReduxAction({
    path,
    value
  })
}

export {
  onlineNetworkAction,
  offlineNetworkAction
}
